import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { goals } from '../data/content';
export function GoalSection() {
  return <section aria-labelledby="meta" className="bg-night" data-id="element-85" data-mp="3sblyuhel8zat">
      <div className="mx-auto max-w-page px-3 py-8 text-center sm:px-6 sm:py-10" data-id="element-86" data-mp="3sd5cs1cruy9f">
        <Reveal data-id="element-87" data-mp="3nd14gym0p9ua">
          <h2 id="meta" className="mx-auto max-w-3xl font-display text-xl uppercase leading-[1.08] text-white sm:text-3xl lg:text-4xl" data-id="element-88" data-mp="3neltk8pkc0kr">
            🎯 Una meta concreta: pasar de “no sé por dónde empezar” a
            comprender la lógica de una instalación domiciliaria
          </h2>
          <p className="mt-2 text-[0.8rem] font-extrabold uppercase tracking-[0.18em] text-volt sm:text-sm" data-id="element-89" data-mp="34l8eze65q6rb">
            Al completar el sistema tendrás una base para:
          </p>
        </Reveal>

        <ul className="mx-auto mt-4 grid max-w-4xl gap-2 text-left sm:grid-cols-2" data-id="element-90" data-mp="jw27xp1e3syx">
          {goals.map((goal, i) => <Reveal key={goal} as="li" delay={i * 0.03} className="flex items-start gap-2 rounded-lg border border-electric/60 bg-night-soft px-3 py-2.5 text-[0.8rem] font-semibold leading-snug text-white sm:text-sm" data-id="element-91" data-mp="2h0lms0cykwfj" data-mpi={i}>
              <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-volt" strokeWidth={3} data-id="element-92" data-mp="2v1ob6jrfeitm" />
              {goal}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-5 max-w-2xl" data-id="element-93" data-mp="22djz9gi9h9ih">
          <p className="text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-94" data-mp="27bbrycqqcznq">
            No se trata de memorizar cientos de páginas.{' '}
            <span className="font-bold text-white" data-id="element-95" data-mp="2c450lbpbks53">
              Se trata de comprender qué estás viendo, por qué funciona y cómo
              razonar frente a un problema.
            </span>
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-5 flex justify-center" data-id="element-96" data-mp="1jjwlq8vu1y77">
          <CtaButton size="lg" data-id="element-97" data-mp="2mvluxpipu9we">
            ¡SÍ! QUIERO APRENDER ELECTRICIDAD DESDE CERO
          </CtaButton>
        </Reveal>
      </div>
    </section>;
}